//import hintaAlueet from "../data/postinumerot2025.geojson";
//import hintaAlueet from "../data/postinumerot2025webmercator.geojson"
//import rajat from "../data/kuntarajat.geojson"
//import rajat from "../data/SykeRakennuksetSelitteet_Pori.json";
import React, { useState, useEffect } from "react";
//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
import kunnat from "kunnat";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
//import ReactGA from "react-ga4";
import { Card, CardContent, Button } from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {
  FIND_STRATEGYMAPS_BY_MUNICIPALITY,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";

//import bgImage from "assets/images/strategia.jpg";
/* eslint-disable react/prop-types */
const Karttapublic = ({ selectedKunta, setError, cookies }) => {
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  // eslint-disable-next-line
  const [x, setX] = useState(61.9);
  // eslint-disable-next-line
  const [y, setY] = useState(21.8);
  const [zoom, setZoom] = useState(13);
  // eslint-disable-next-line
  const [idea, setIdea] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  // eslint-disable-next-line
  const [ideatext, setIdeatext] = useState("");
  // eslint-disable-next-line
  const [selectedIdea, setSelectedIdea] = useState(t("strategy.vision"));
  const [votes, setVotes] = useState([]);
  let vote = [];
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  const [smapitems, setSmapitems] = useState([]);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  const smapitemssw = useQuery(FIND_STRATEGYMAPS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let smapitemss = [];
    //console.log(smapitemssw);
    //let municipalitiess = [];
    if (smapitemssw.data) {
      smapitemss = smapitemssw.data.findStrategymapsByMunicipality;
      //setOrgans(organss);
      //console.log(smapitemss);
      //let secs = smapitemss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsmapitems(secs);
      setSmapitems(smapitemss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [smapitemssw]);
  console.log(cookies);
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addmapitem)
    }*/
  });

  const handleVote = (event) => {
    //console.log(event);
    if (vote.filter((a) => a === event).length > 0) {
      window.confirm("Olet jo peukuttanut tätä kohdetta");
    } else {
      const aika = Date.now();
      const pvm = new Date(aika);
      vote.push(event);
      createVoting({
        variables: {
          strategymapid: event,
          userid: "anonym",
          votedatetime: pvm.toString(),
          municipality: selectedKunta,
        },
      });
    }
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategymapid === p).length;
  }
  // Fix marker icon issue
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  });
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  useEffect(() => {
    let selected = kunnat.filter((mun) => mun.name === selectedKunta);
    //console.log(selected);
    setX(selected[0].x);
    setY(selected[0].y);
    setZoom(13);
  }, []);
  useEffect(() => {
    let selected = kunnat.filter((mun) => mun.name === selectedKunta);
    //console.log(selected);
    setX(selected[0].x);
    setY(selected[0].y);
    //console.log(x);
    //console.log(y);
  }, [selectedKunta]);
  const Centerer = ({ center }) => {
    const map = useMap();
    useEffect(() => {
      map.setView(center);
    }, [center, map]);

    return null;
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <h3>{t("map.header")}</h3>
      <p>{t("map.text")}</p>
      <div style={{ zIndex: 0 }}>
        <MapContainer
          center={[x, y]}
          zoom={zoom}
          style={{ zIndex: 0, height: "80vh", width: "100%" }}
        >
          <TileLayer
            style={{ zIndex: 0, height: "80vh", width: "100%" }}
            attribution="&copy; OpenStreetMap"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Centerer center={[x, y]} />
          {smapitems.map((marker, idx) => (
            <Marker key={idx} position={[marker.x, marker.y]}>
              <Popup>{marker.maptext}</Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <br />
      <MKTypography variant="h4" gutterBottom>
        {t("strategy.mapitemwall")}
      </MKTypography>
      {smapitems.length === 0 && <MKTypography>{t("strategy.noideas")}</MKTypography>}
      {smapitems.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>{item.maptext}</MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Karttapublic;
